import React, { FC } from 'react'

import { BlogPost } from '../BlogPost'
import { BlogPost as BlogPostType } from '../types'
import { Container } from './BlogPostsDesktop.styles'

type Props = {
  entries: BlogPostType[]
  id?: string
  className?: string
}

export const BlogPostsDesktop: FC<Props> = ({ entries, ...props }) => (
  <Container {...props}>
    {entries.map(entry => (
      <BlogPost key={entry.title} {...entry} />
    ))}
  </Container>
)
